/**
 * PURPOSE: Types, constants, and drawing helpers for photo annotation
 */
import { Pencil, ArrowUpRight, Circle, Type } from 'lucide-react'

export type AnnotationTool = 'draw' | 'arrow' | 'circle' | 'text'

export interface Point { x: number; y: number }

export interface Annotation {
  tool: AnnotationTool; color: string; lineWidth: number
  points?: Point[]; start?: Point; end?: Point; text?: string; position?: Point
}

export interface PhotoAnnotationProps {
  imageUrl: string; onSave: (annotatedBlob: Blob) => void; onCancel: () => void
}

export const COLORS = [
  { value: '#ef4444', label: 'Red' }, { value: '#f59e0b', label: 'Yellow' },
  { value: '#3b82f6', label: 'Blue' }, { value: '#ffffff', label: 'White' },
  { value: '#000000', label: 'Black' },
]

export const TOOLS: { tool: AnnotationTool; icon: typeof Pencil; label: string }[] = [
  { tool: 'draw', icon: Pencil, label: 'Draw' }, { tool: 'arrow', icon: ArrowUpRight, label: 'Arrow' },
  { tool: 'circle', icon: Circle, label: 'Circle' }, { tool: 'text', icon: Type, label: 'Text' },
]
